import { Block } from "@/components/Block";
import {
  Header,
  HeaderActionBack,
  HeaderActionCustomerService,
} from "@/components/Header";
import { Icon } from "@/components/Icon";
import { Input } from "@/components/Input";
import { Layout } from "@/components/Layout";
import { Level } from "@/components/Level";
import {
  PaymentSelector,
  PaymentSelectorProps,
} from "@/components/PaymentSelector";
import { TradeBoard } from "@/components/TradeBoard";
import { OrderType } from "@/constants";
import { amountFormat } from "@/utils/tool";
import { Avatar, Button, SafeArea } from "antd-mobile";
import styles from "./index.module.scss";
import { useSetup } from "./logic";
import { Empty } from "@/components/Empty";

const SellerInfo = ({
  order,

}: any) => {
  return <Block title="卖方信用资讯" topline>
    {
      order.sellerIndicator ? (
        <>
          <div className={styles.lineOfSellerInfo}>
            <div className={styles.itemOfSellerInfo}>
              <div className={styles.keyOfSellerInfo}>
                {order.sellerIndicator?.range}日成单数
              </div>
              <div className={styles.valueOfSellerInfo}>
                {order.sellerIndicator?.totalSuccessfulOrder || 0}
              </div>
            </div>
            <div className={styles.itemOfSellerInfo}>
              <div className={styles.keyOfSellerInfo}>
                {order.sellerIndicator?.range}日成单率{" "}
              </div>
              <div className={styles.valueOfSellerInfo}>
                {order.sellerIndicator?.totalSuccessRate || 0}%
              </div>
            </div>
          </div>

          <div className={styles.lineOfSellerInfo}>
            <div className={styles.itemOfSellerInfo}>
              <div className={styles.keyOfSellerInfo}>
                {order.sellerIndicator?.range}日平均放币时间{" "}
              </div>
              <div className={styles.valueOfSellerInfo}>
                {order.sellerIndicator?.sellerAvgTime ? "<" : ''}
                {order.sellerIndicator?.sellerAvgTime || 0} 分钟
              </div>
            </div>
            <div className={styles.itemOfSellerInfo}>
              <div className={styles.keyOfSellerInfo}>
                {order.sellerIndicator?.range} 日平均付款时间{" "}
              </div>
              <div className={styles.valueOfSellerInfo}>
                {"<"}
                {order.sellerIndicator?.buyerAvgTime || 0}分钟
              </div>
            </div>
          </div>

          <div className={styles.lineOfSellerInfo}>
            <div className={styles.itemOfSellerInfo}>
              <div className={styles.keyOfSellerInfo}>买单</div>
              <div className={styles.valueOfSellerInfo}>
                {" "}
                {order.sellerIndicator?.buyerOrder || 0}笔
              </div>
            </div>
            <div className={styles.itemOfSellerInfo}>
              <div className={styles.keyOfSellerInfo}>卖单 </div>
              <div className={styles.valueOfSellerInfo}>
                {order.sellerIndicator?.sellerOrder || 0}笔
              </div>
            </div>
          </div>
        </>
      ) : (<Empty />)
    }

  </Block>
}

export const PageBuy = () => {
  const logic = useSetup();

  if (!logic.order) return <></>;

  return (
    <Layout
      scrollable
      backgroundImage={false}
      header={
        <Header
          title="购买V币"
          leftActions={[<HeaderActionBack />]}
          rightActions={[<HeaderActionCustomerService />]}
        />
      }
    >
      <div className={styles.main}>
        <TradeBoard
          contentClassName={styles.boardContent}
          backgroundClassName={styles.boardBackground}
          background={
            <>
              <div className={styles.content}>
                <Avatar
                  className={styles.avatar}
                  alt="avatar"
                  src={logic.getSourcePath(logic.order.sellerAvatar)}
                />
                <div>
                  <div className={styles.username}>
                    {logic.order.sellerNickname}
                  </div>
                  <div className={styles.levelWrapper}>
                    <div className={styles.levelLabel}>信用等级</div>
                    <Level level={logic.order.sellerCreditLevel} />
                  </div>
                </div>
              </div>
              <div className={styles.orderType}>
                {logic.order.isSplit === OrderType.SEPARABLY
                  ? "可拆分"
                  : "不可拆分"}
              </div>
            </>
          }
        >
          <div className={styles.validAmount}>可购买总额</div>
          <div className={styles.amount}>
            <span>{amountFormat(logic.order.validAmount)}</span>
            <Icon name={"vcoin"} className={styles.amountIcon} />
          </div>
        </TradeBoard>
        {
          logic.showSellerInfo ? (<SellerInfo order={logic.order} />) : null
        }

        {
          //可拆分才显示购买数量
          logic.order.isSplit === OrderType.SEPARABLY ?  (
            <Block title="购买数量">
              <Input
                className={styles.buyAmountInput}
                theme={"plain"}
                placeholder={`${logic.order.minBuyEach}~${logic.order.validAmount}`}
                onChange={(e) => {
                  logic.dispatch({ type: "update-amount", amount: e.target.value });
                }}
              />
            </Block>
          ):null
        }

        <Block title="支付方式">
          <PaymentSelector
            isBuyer
            validPayments={logic.order.paymentType}
            onChange={
              (([paymentType, buyerPaymentTypeId]) => {
                logic.dispatch({
                  type: "update-payments",
                  buyerPaymentTypeId,
                  paymentType,
                });
              }) as PaymentSelectorProps["onChange"]
            }
          />
        </Block>
        <Button
          fill="none"
          className={styles.confirmButton}
          onClick={() => {logic.submit()}}
        >
          确定购买
        </Button>
        <div className={styles.warning}>
          确认购买后如未自动跳转 请到交易中查看我的买单
        </div>
        <SafeArea position="bottom" />
      </div>
    </Layout>
  );
};
